import { render } from "./TestTypeSection.vue?vue&type=template&id=f8da544c"
import script from "./TestTypeSection.vue?vue&type=script&lang=js"
export * from "./TestTypeSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__